export default {
  header: {
    display: 'flex',
    alignItems: 'center',
    marginBottom: 16,
    height: 26,
    margin: 0
  },
  title: {
    flexShrink: 2,
    margin: 0,
    overflow: 'hidden',
    whiteSpace: 'nowrap',
    textOverflow: 'ellipsis'
  },
  button: {
    border: 'none',
    backgroundColor: 'transparent',
    cursor: 'pointer',
    marginLeft: 8
  },
  editingButtons: {
    display: 'flex',
    flexShrink: 0,
    marginLeft: 16,
    justifyContent: 'space-between',
    width: 110
  }
}
